import { render, staticRenderFns } from "./MoodRecordCom.vue?vue&type=template&id=2df71fb6&scoped=true"
import script from "./MoodRecordCom.vue?vue&type=script&lang=js"
export * from "./MoodRecordCom.vue?vue&type=script&lang=js"
import style0 from "./MoodRecordCom.vue?vue&type=style&index=0&id=2df71fb6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df71fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df71fb6')) {
      api.createRecord('2df71fb6', component.options)
    } else {
      api.reload('2df71fb6', component.options)
    }
    module.hot.accept("./MoodRecordCom.vue?vue&type=template&id=2df71fb6&scoped=true", function () {
      api.rerender('2df71fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/MoodRecordCom.vue"
export default component.exports